import Cookies from 'js-cookie';
import { useEffect } from 'react';

import { COGNITO_COOKIE_DOMAIN } from '../../../config/Environment';
import { NavinaCookiesError, NavinaThirdPartyCookiesError } from '../../ErrorPage/Errors';

function setTestCookieAndCheckIfItExists(): boolean {
	try {
		const testCookieName = 'navina-test-cookie';
		const testCookieValue = '1';

		Cookies.set(testCookieName, testCookieValue, {
			sameSite: 'None',
			secure: true,
			domain: COGNITO_COOKIE_DOMAIN,
		});

		const cookieExists = Cookies.get(testCookieName) === testCookieValue;

		Cookies.remove(testCookieName);

		return cookieExists;
	} catch {
		return false;
	}
}

function areCookiesEnabled(): boolean {
	if (!navigator.cookieEnabled) {
		return false;
	}

	if (document.cookie && document.cookie.length > 0) {
		return true;
	}

	return setTestCookieAndCheckIfItExists();
}

function isEmbeddedInIFrame(): boolean {
	try {
		// If window.self is not equal to window.top, we're in an iframe
		return globalThis.self !== window.top;
	} catch {
		// A cross-origin error likely means we're in an iframe
		return true;
	}
}

export const CookiesTester = function CookiesTester() {
	useEffect(function testCookies() {
		const cookiesEnabled = areCookiesEnabled();
		if (!cookiesEnabled) {
			if (isEmbeddedInIFrame()) {
				throw new NavinaThirdPartyCookiesError();
			}

			throw new NavinaCookiesError();
		}
	}, []);

	return null;
};
